import { dispatch } from 'lib/store'
import log from 'lib/log'
import {
  SET_TIME_RANGE,
  SET_DATE_FILTER,
  ADD_ATTRIBUTE_VALUE_FILTER,
  REMOVE_ATTRIBUTE_VALUE_FILTER,
  CLEAR_ATTRIBUTE_VALUE_FILTERS,
} from 'constants/action-types'
import { TimeRange } from 'types/search/filters'
import { calculateEffectiveDateRange } from 'lib/search/calculate-effective-date-range'
import { getTimeRange, getCustomDateRange } from 'selectors/search/filters'

/**
 * Set time range preset
 * When switching to CUSTOM, calculates and saves the effective date range
 * from the current preset so the date picker has pre-filled values
 */
export const setTimeRange = (timeRange: TimeRange): void => {
  // When switching TO custom, pre-populate with current effective range
  if (timeRange === TimeRange.CUSTOM) {
    // Get current values from selectors (encapsulated state access)
    const previousTimeRange = getTimeRange()
    const previousCustomDateRange = getCustomDateRange()

    // Calculate effective dates from the PREVIOUS preset
    const effectiveDateRange = calculateEffectiveDateRange(
      previousTimeRange,
      previousCustomDateRange.startDate,
      previousCustomDateRange.endDate,
    )

    // Dispatch both actions
    dispatch(SET_TIME_RANGE, timeRange)
    dispatch(SET_DATE_FILTER, {
      startDate: effectiveDateRange.startDate,
      endDate: effectiveDateRange.endDate,
    })
  } else {
    // For presets, just set the time range
    dispatch(SET_TIME_RANGE, timeRange)
  }
}

/**
 * Set custom date filter (from chart zoom/click or date picker)
 * Automatically sets time range to CUSTOM and stores the custom dates
 */
export const setCustomDateFilter = (
  startDate: string | null,
  endDate: string | null,
): void => {
  // First set time range to CUSTOM
  dispatch(SET_TIME_RANGE, TimeRange.CUSTOM)

  // Then set the custom date range
  dispatch(SET_DATE_FILTER, { startDate, endDate })
}

export const addAttributeValueFilter = (
  attributeCode: string,
  value: string,
): void => {
  dispatch(ADD_ATTRIBUTE_VALUE_FILTER, { attributeCode, value })
  log.info('Filter applied', { attributeCode, value })
}

export const removeAttributeValueFilter = (
  attributeCode: string,
  value: string,
): void => {
  dispatch(REMOVE_ATTRIBUTE_VALUE_FILTER, { attributeCode, value })
  log.info('Filter removed', { attributeCode, value })
}

export const clearAttributeValueFilters = (): void => {
  dispatch(CLEAR_ATTRIBUTE_VALUE_FILTERS, undefined)
  log.info('Filters cleared')
}
